exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reservationForm th{text-align:left}.reservationForm tfoot th{font-size:11pt;font-weight:400;line-height:1.2}.reservationForm tfoot th.is-danger{color:#d8842e}.reservationForm tfoot th.is-info{color:#1a6e74}.reservationForm .input.numberInput{width:5em}.reservationForm .costs-table{margin-bottom:40px}.reservationForm .party-cost-row:not(:last-child) td{padding-bottom:10px}", ""]);

// exports
